import React, { useState } from 'react';

const Faq = () => {
  const [open, setOpen] = useState(null);

  const toggleAnswer = (index) => {
    setOpen(open === index ? null : index);
  };

  const faqs = [
    {
      question: "How does Adopt a Pet Grooming Service Work?",
      answer: "Adopt a Pet Grooming Service allows you to book a professional pet groomer to come to your home. You can schedule a session online at your convenience, and the groomer brings all the necessary equipment."
    },
    {
      question: "Can I Book a specific Groomer?",
      answer: "Yes, you can book a specific groomer if you'd like. Simply check the groomer's availability while booking."
    },
    {
      question: "Can I re-book the same Pet Groomer again?",
      answer: "Yes, you can re-book the same pet groomer for future sessions. Simply select them during the booking process."
    },
    {
      question: "What is the cancellation policy?",
      answer: "You can cancel or reschedule the grooming service up to 24 hours before your appointment. Any cancellations made within 24 hours may incur a small fee."
    },
    {
      question: "Should I leave a Tip? How do I Leave One?",
      answer: "Tipping is not mandatory, but it is appreciated for great service. You can leave a tip in cash directly to the groomer or through the mobile app."
    },
    {
      question: "What do I need to Provide the Pet Groomer?",
      answer: "You don't need to provide anything except for access to your pet. The groomer will bring all the necessary equipment and products required for the grooming session."
    }
  ];

  return (
    <div>
      <div className="bg-gray-100 py-10 mt-10">
        <div className="container mx-auto px-4 text-center">
          <p className="text-3xl font-bold mb-6">FAQ</p>

          <div className="bg-white p-6 rounded-lg shadow-lg">
            {faqs.map((faq, index) => (
              <div key={index} className="mb-4">
                <div
                  className="text-xl font-semibold cursor-pointer flex items-center justify-between"
                  onClick={() => toggleAnswer(index)}
                >
                  <span>{faq.question}</span>
                  <span className="text-xl">{open === index ? "−" : "+"}</span>
                </div>
                {open === index && (
                  <div className="text-gray-600 mt-2">
                    <p>{faq.answer}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Faq;
